/**
 * Constants file for Perkins V data, indicators, and definitions
 */

// State targets for each indicator by year (2020-2023)
export const perkinsStateTargets = {
    "1S1": [0.836, 0.847, 0.857, 0.868],
    "1S2": [0.866, 0.877, 0.887, 0.898],
    "2S1": [0.764, 0.787, 0.809, 0.832],
    "2S2": [0.571, 0.626, 0.681, 0.736],
    "2S3": [0.502, 0.568, 0.635, 0.701],
    "3S1": [0.67, 0.702, 0.734, 0.766],
    "4S1": [0.518, 0.548, 0.578, 0.608],
    "5S1": [0.43, 0.46, 0.49, 0.52],
    "5S2": [0.815, 0.829, 0.843, 0.857],
    "5S3": [0.9, 0.914, 0.928, 0.942],
  };
  
  // Indicator descriptions
  export const indicatorDescriptions = {
    '1S1': 'Four-Year Graduation Rate',
    '1S2': 'Extended Graduation Rate',
    '2S1': 'Academic Proficiency in Reading/Language Arts',
    '2S2': 'Academic Proficiency in Mathematics',
    '2S3': 'Academic Proficiency in Science',
    '3S1': 'Post-Program Placement',
    '4S1': 'Non-traditional Program Concentration',
    '5S1': 'Program Quality – Attained Recognized Postsecondary Credential',
    '5S2': 'Program Quality – Attained Postsecondary Credits',
    '5S3': 'Program Quality – Participated in Work-Based Learning',
  };
  
  // Order and categorization of student groups
  export const studentGroupCategories = {
    "All": [
      "All Students"
    ],
    "Gender": [
      "Female",
      "Gender X",
      "Male"
    ],
    "Race/Ethnicity": [
      "American Indian/ Alaskan Native",
      "Asian",
      "Black/ African American",
      "Hispanic/ Latino of any race(s)",
      "Native Hawaiian/ Other Pacific Islander",
      "Two or More Races",
      "White"
    ],
    "Special": [
      "English Language Learners",
      "Highly Capable",
      "Homeless",
      "Low-Income",
      "Migrant",
      "Military Parent",
      "Section 504",
      "Students with Disabilities",
      "Students without Disabilities"
    ],
    "Non": [
      "Non Migrant",
      "Non Military Parent",
      "Non Section 504",
      "Non-English Language Learners",
      "Non-Highly Capable",
      "Non-Homeless",
      "Non-Low Income"
    ]
  };
  
  // Year labels
  export const yearLabels = ['2020', '2021', '2022', '2023'];
  
  // Get all indicator codes
  export const allIndicators = Object.keys(perkinsStateTargets);
  
  // Function to determine if a group is in a special population
  export const isSpecialPopulation = (group) => {
    return studentGroupCategories["Special"].includes(group);
  };
  
  // Function to determine if a group is a demographic group
  export const isDemographicGroup = (group) => {
    return studentGroupCategories["Race/Ethnicity"].includes(group) ||
           studentGroupCategories["Gender"].includes(group);
  };
  
  // Color configurations
  export const heatmapColorConfig = {
    type: 'diverging',
    scheme: 'red_blue',  // Ensure this is "red_blue" not "blues_reds"
    minValue: -0.2,
    maxValue: 0.2,
    divergeAt: 0.5,
  };
  
  // Category colors for headers
  export const categoryColors = {
    "All": "#1976D2",       // Blue
    "Gender": "#7B1FA2",    // Purple
    "Race/Ethnicity": "#388E3C", // Green
    "Special": "#D32F2F",   // Red
    "Non": "#F57C00",       // Orange
    "Other": "#616161"      // Grey
  };